import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { verifyEmail } from '../actions/auth-actions';
import PublicUserHeader from './PublicUserHeader';

import claverTheme from '../../layout/components/layout/components/theme/claverTheme';
import { GoUnverified } from "react-icons/go";
import { ChakraBaseProvider, Skeleton, Flex, Divider, Text, Box, Image, Spinner } from "@chakra-ui/react";
import EmailVerifiedIcon from '../styles/images/email-verified.svg';
import '../styles/authentication.scss';


function VerifyEmailPage({
	match,
	// Action
	verifyEmail,
	// Redux
	retrievedEmailVerificationStatus
}) {


	const initRef = useRef(false);
	const [isVerified, setIsVerified] = useState(null)

	useEffect(() => {
		if (!initRef.current) {

			const { verifyEmailToken } = match.params || {};
			verifyEmailToken && verifyEmail(verifyEmailToken)

			initRef.current = true;
		}

	}, []);

	useEffect(() => {
		if (retrievedEmailVerificationStatus) {
			const { data } = retrievedEmailVerificationStatus;
			const userIsVerified = data ? data.verifiedUser.isVerified : "";
			setIsVerified(userIsVerified)

		}

	}, [retrievedEmailVerificationStatus]);




	return (
		<ChakraBaseProvider theme={claverTheme}>
			<PublicUserHeader />

			<Box className="authentication-container">
				<Box pt='5em'>
					<Flex m='auto' direction='column' justify='center' alignItems='center' bg='white' maxWidth='37.5em' minHeight='20em' pb='3rem' rounded='0.25em' className='default-box-shadow'>
						<VerificationOutcomeMessage isVerified={isVerified} />
					</Flex>
				</Box>
			</Box>
		</ChakraBaseProvider>

	);

}

function VerificationOutcomeMessage({ isVerified }) {
	return (
		<>
			{
				{
					"": <>
						<Flex m='3%' direction='column' alignItems='center' justify='center' minHeight='38vh'>
							<Flex justifiy='center'>
								<Spinner
									thickness="0.25em"
									speed="0.65s"
									emptyColor="gray.200"
									color="brand.500"
									boxSize="5em"
									zIndex='10'
								/>
							</Flex>
							<Box mt='2em' textAlign='center' color='gray.700'>Working on it...</Box>
						</Flex>
						<Divider my='3%' />
						<Skeleton height='2.5rem' />
					</>,
					false:
						<Box w='100%' p='2em'>

							<Flex w='100%' justify='center'>
								<Box as={GoUnverified} boxSize="5em" color="red.400" />
							</Flex>

							<Flex alignItems='center' justify='center' direction='column'>
								<Text fontSize={'1.5em'} lineHeight='1.875em' fontWeight='500' color='gray.700' textAlign='center' mt='2.2em' >
									Expired activation link
								</Text>
								<Text fontSize={'1em'} lineHeight='1.375em' fontWeight='400' color='gray.500' textAlign='center' mt='1em' >
									Please request for a new link and activate using it
								</Text>
								<Link to={`/login`}> <Text fontSize='0.9em' color='brand.500' fontWeight='semibold' mt='2em'>Back to Launchdeck </Text></Link>
							</Flex>
						</Box>,
					true:
						<Box w='100%' p='2em'>
							<Flex w='100%' justify='center'>
								<Image src={EmailVerifiedIcon} alt="Email Verified" boxSize='5em' draggable={false} />
							</Flex>

							<Flex alignItems='center' justify='center' direction='column'>
								<Text fontSize={'1.2em'} lineHeight='1.875em' fontWeight='500' color='gray.700' textAlign='center' mt='2.2em' >
									Email address verified
								</Text>
								<Text fontSize={'0.875em'} lineHeight='1.375em' fontWeight='400' color='gray.500' textAlign='center' mt='1em' >
									We're now able to send important notifications over when needed.
								</Text>
							</Flex>
						</Box>
				}[isVerified]
			}
		</>
	);
}


function mapStateToProps(state) {
	return {
		retrievedEmailVerificationStatus: state.emailVerificationStatus.results
	};
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			verifyEmail
		},
		dispatch,
	)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VerifyEmailPage));
